import { makeAutoObservable } from 'mobx';
import IGeoCoordinate from '../interfaces/IGeoCoordinate';

export default class MapRadiusStore {
    coordinates: IGeoCoordinate | null = null;
    radius: number = 0;
    lock: string = "";

    constructor() {
        makeAutoObservable(this);
    }

    draw(coordinates: IGeoCoordinate, radius: number, lock: string) {
        this.coordinates = coordinates;
        this.radius = radius;
        this.lock = lock;
    }

    clear(lock: string) {
        if (this.lock === lock)
            this.coordinates = null;
    }

    clearForLogout() {
        this.coordinates = null;
        this.radius = 0;
        this.lock = "";
    }
}